import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: ServicePaymentTransactionState = {};

const getters: GetterTree<ServicePaymentTransactionState, RootState> = {};

const actions: ActionTree<ServicePaymentTransactionState, RootState> = {
  markInvoicePaid(_, { oid, payload }) {
    return http.v1.spt.markInvoicePaid(oid, payload);
  },
};

const mutations: MutationTree<ServicePaymentTransactionState> = {};

const servicePaymentTransaction: Module<
  ServicePaymentTransactionState,
  RootState
> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default servicePaymentTransaction;
